///<reference path="babylon.d.ts" />
///<reference path="babylonjs.materials.d.ts" />
///<reference path="babylon.gui.d.ts" />
var game;
var Game = /** @class */ (function () {
    function Game(canvasElement) {
        // Create canvas and engine.
        this._canvas = document.getElementById('renderCanvas');
        this._engine = new BABYLON.Engine(this._canvas, true, {}, true);
    }
    Game.prototype.createScene = function () {
        var _this = this;
        var self = this;
        self._fishing_pole = null;
        self._fishing_bobber = null;
        self._fishing_reel = null;
        // Create a basic BJS Scene object.
        self._scene = new BABYLON.Scene(self._engine);
        //_self._scene.debugLayer.show();
        //this._asset_manager = new BABYLON.AssetsManager(self._scene);
        // Create a FreeCamera, and set its position to (x:0, y:5, z:-10).
        self._camera = new BABYLON.ArcRotateCamera("Camera", Math.PI * 1.53, Math.PI / 2.2, 120, BABYLON.Vector3.Zero(), self._scene);
        // Attach the camera to the canvas.
        self._camera.attachControl(self._canvas, false);
        self._camera.inputs.clear(); // lock the camera
        // Create a basic light, aiming 0,1,0 - meaning, to the sky.
        self._scene.createDefaultLight();
        self._light = new BABYLON.HemisphericLight('light1', new BABYLON.Vector3(0, 1, 0), self._scene);
        // Skybox
        var skybox = BABYLON.Mesh.CreateBox("skyBox", 2000.0, self._scene);
        var skyboxMaterial = new BABYLON.StandardMaterial("skyBox", self._scene);
        skyboxMaterial.backFaceCulling = false;
        skyboxMaterial.reflectionTexture = new BABYLON.CubeTexture("assets/dist/img/scene/generic/skybox/sunnyday", self._scene);
        skyboxMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
        skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
        skyboxMaterial.disableLighting = true;
        skybox.material = skyboxMaterial;
        self._idle_animation = new BABYLON.AnimationGroup("idle");
        self._cast_animation = new BABYLON.AnimationGroup("cast");
        self._fishing_animation = new BABYLON.AnimationGroup("fishing");
        self._reel_in_animation = new BABYLON.AnimationGroup("reel-in");
        self._cast_animation.onAnimationEndObservable.add(function (e) {
            // bobber is the last animation to finish
            if (e.animation.name == "bobber-cast") {
                self._fishing_animation.play(true);
                document.dispatchEvent(new Event('game:CastEnded'));
            }
        });
        self._reel_in_animation.onAnimationEndObservable.add(function () {
            document.dispatchEvent(new Event('game:ReelInEnded'));
        });
        // Load Materials
        // Water material
        this._waterMaterial = new BABYLON.WaterMaterial("waterMaterial", self._scene, new BABYLON.Vector2(512, 512));
        this._waterMaterial.bumpTexture = new BABYLON.Texture("assets/dist/img/scene/lake/textures/waterbump.png", self._scene);
        this._waterMaterial.colorBlendFactor = 0;
        this._waterMaterial.windDirection = new BABYLON.Vector2(1, 1);
        this._waterMaterial.windForce = -1;
        this._waterMaterial.waveHeight = 0.1;
        this._waterMaterial.waveLength = .1;
        this._waterMaterial.waveSpeed = 10;
        this._waterMaterial.bumpHeight = 0.1;
        // Chippewa Flowage
        var shoreMaterial1 = new BABYLON.StandardMaterial("shorelineMaterialChippewaFlowage", self._scene);
        shoreMaterial1.diffuseTexture = new BABYLON.Texture("assets/dist/img/scene/lake/textures/shoreline-chippewa-flowage.jpg", self._scene);
        shoreMaterial1.diffuseTexture.hasAlpha = true;
        shoreMaterial1.backFaceCulling = false;
        // Eagle River Chain of Lakes
        var shoreMaterial2 = new BABYLON.StandardMaterial("shorelineMaterialEagleRiver", self._scene);
        shoreMaterial2.diffuseTexture = new BABYLON.Texture("assets/dist/img/scene/lake/textures/shoreline-eagle-river.jpg", self._scene);
        shoreMaterial2.diffuseTexture.hasAlpha = true;
        shoreMaterial2.backFaceCulling = false;
        // Lake Michigan
        var shoreMaterial3 = new BABYLON.StandardMaterial("shorelineMaterialLakeMichigan", self._scene);
        shoreMaterial3.diffuseTexture = new BABYLON.Texture("assets/dist/img/scene/lake/textures/shoreline-lake-michigan.jpg", self._scene);
        shoreMaterial3.diffuseTexture.hasAlpha = true;
        shoreMaterial3.backFaceCulling = false;
        // Lake Winnebago
        var shoreMaterial4 = new BABYLON.StandardMaterial("shorelineMaterialLakeWinnebago", self._scene);
        shoreMaterial4.diffuseTexture = new BABYLON.Texture("assets/dist/img/scene/lake/textures/shoreline-lake-winnebago.jpg", self._scene);
        shoreMaterial4.diffuseTexture.hasAlpha = true;
        shoreMaterial4.backFaceCulling = false;
        // Sand
        var sandTexture = new BABYLON.Texture("assets/dist/img/scene/lake/textures/ground-sand.jpg", self._scene);
        sandTexture.vScale = sandTexture.uScale = 4.0;
        var sandMaterial = new BABYLON.StandardMaterial("sandMaterial", self._scene);
        sandMaterial.diffuseTexture = sandTexture;
        // Blue Texture
        var blueTexture = new BABYLON.Texture("assets/dist/img/scene/lake/textures/ground-blue.jpg", self._scene);
        blueTexture.vScale = blueTexture.uScale = 4.0;
        var blueMaterial = new BABYLON.StandardMaterial("blueMaterial", self._scene);
        blueMaterial.diffuseTexture = blueTexture;
        /// MESHES
        // Water mesh
        var water = BABYLON.MeshBuilder.CreateGround("waterMesh", { height: 1024, width: 2048, subdivisions: 32, updatable: false }, self._scene);
        water.material = this._waterMaterial;
        // Ground
        self._ground = BABYLON.MeshBuilder.CreateGround("ground", { height: 1024, width: 2048, subdivisions: 32, updatable: false }, self._scene);
        self._ground.position.y = -20;
        self._ground.material = sandMaterial;
        // shoreline mesh
        self._shoreline = BABYLON.MeshBuilder.CreatePlane("shoreline", { height: 744, width: 2048, sideOrientation: BABYLON.Mesh.DOUBLESIDE }, self._scene);
        self._shoreline.material = shoreMaterial1;
        self._shoreline.position.z = 512;
        self._shoreline.position.y = 372;
        // Configure water material
        this._waterMaterial.addToRenderList(self._ground);
        this._waterMaterial.addToRenderList(skybox);
        this._waterMaterial.addToRenderList(self._shoreline);
        // import models
        BABYLON.SceneLoader.ImportMesh("", "models/", "pole.gltf", self._scene, function (newMeshes, particleSystems, skeletons) {
            self._scene.getAnimationGroupByName("pole").stop();
            self._scene.getAnimationGroupByName("reel").stop();
            newMeshes[0].name = "pole";
            //newMeshes[1].name = "reel";
            self._fishing_pole = newMeshes[0];
            var yaw = .5 * 2 * Math.PI;
            var pitch = .1 * 2 * Math.PI;
            var roll = 0 * 2 * Math.PI;
            //self._fishing_pole.rotationQuaternion = yprQuaternion;
            self._fishing_pole.rotate(BABYLON.Axis.Y, yaw, BABYLON.Space.LOCAL);
            //self._fishing_pole.rotate(BABYLON.Axis.X, pitch, BABYLON.Space.LOCAL);
            self._fishing_pole.rotate(BABYLON.Axis.Z, roll, BABYLON.Space.LOCAL);
            //self._fishing_pole.scaling = new BABYLON.Vector3(10,10,10);
            self._fishing_pole.position.z = -100;
            self._fishing_pole.position.y = 7;
            var idleRange = new BABYLON.AnimationRange("idle", 431, 520);
            var castRange = new BABYLON.AnimationRange("cast", 0, 40);
            var fishingRange = new BABYLON.AnimationRange("fishing", 41, 400);
            var reelRange = new BABYLON.AnimationRange("reel-in", 400, 420);
            var keys = [];
            //self._scene.getAnimationGroupByName("pole").normalize();
            for (var _i = 0, _a = self._scene.getAnimationGroupByName("pole").targetedAnimations; _i < _a.length; _i++) {
                var targetedAnimation = _a[_i];
                if (targetedAnimation.animation.name == 'pole_channel0') {
                    var idleAnimation = targetedAnimation.animation.clone();
                    keys = idleAnimation.getKeys();
                    idleAnimation.setKeys(keys.slice(idleRange.from, idleRange.to));
                    self._idle_animation.addTargetedAnimation(idleAnimation, targetedAnimation.target);
                    var castAnimation = targetedAnimation.animation.clone();
                    keys = castAnimation.getKeys();
                    castAnimation.setKeys(keys.slice(castRange.from, castRange.to));
                    self._cast_animation.addTargetedAnimation(castAnimation, targetedAnimation.target);
                    var fishingAnimation = targetedAnimation.animation.clone();
                    keys = fishingAnimation.getKeys();
                    fishingAnimation.setKeys(keys.slice(fishingRange.from, fishingRange.to));
                    self._fishing_animation.addTargetedAnimation(fishingAnimation, targetedAnimation.target);
                    var fishingAnimation = targetedAnimation.animation.clone();
                    keys = fishingAnimation.getKeys();
                    fishingAnimation.setKeys(keys.slice(fishingRange.from, fishingRange.to));
                    self._fishing_animation.addTargetedAnimation(fishingAnimation, targetedAnimation.target);
                    /*
                    var reelAnimation = targetedAnimation.animation.clone();
                    keys = reelAnimation.getKeys();
                    reelAnimation.setKeys(keys.slice(reelRange.from, reelRange.to));
                    self._reel_in_animation.addTargetedAnimation(reelAnimation, targetedAnimation.target);
                    */
                }
            }
            for (var _b = 0, _c = self._scene.getAnimationGroupByName("reel").targetedAnimations; _b < _c.length; _b++) {
                var targetedAnimation = _c[_b];
                if (targetedAnimation.animation.name == 'reel_channel0') {
                    var reelInAnimation = targetedAnimation.animation.clone();
                    keys = reelInAnimation.getKeys();
                    reelInAnimation.setKeys(keys.slice(reelRange.from, reelRange.to));
                    self._reel_in_animation.addTargetedAnimation(reelInAnimation, targetedAnimation.target);
                }
            }
            self._scene.getAnimationGroupByName("idle").start(true);
        });
        BABYLON.SceneLoader.ImportMesh("", "models/", "bobber.glb", self._scene, function (newMeshes) {
            newMeshes[0].name = "bobber";
            self._fishing_bobber = newMeshes[0];
            self._fishing_bobber.position = new BABYLON.Vector3(180, 40, -100);
            // define curved path for bobber to animate on
            var bobberCubicBezierVectors = BABYLON.Curve3.CreateCubicBezier(new BABYLON.Vector3(180, 40, -100), new BABYLON.Vector3(60, 50, -25), new BABYLON.Vector3(30, 60, -20), new BABYLON.Vector3(0, 3, 0), 60);
            // draw line for visual reference of the curve
            //var cubicBezierCurve = BABYLON.Mesh.CreateLines("cbezier", bobberCubicBezierVectors.getPoints(), self._scene);
            //cubicBezierCurve.color = new BABYLON.Color3(1, 0.6, 0);
            // Create the animation and add to the mesh
            var animationCastBobber = new BABYLON.Animation("bobber-cast", "position", 30, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
            var keys = [];
            var bobberCurvePoints = bobberCubicBezierVectors.getPoints();
            for (i = 0; i < bobberCurvePoints.length; i++) {
                keys.push({
                    frame: i,
                    value: bobberCurvePoints[i]
                });
            }
            animationCastBobber.setKeys(keys);
            self._fishing_bobber.animations = [];
            self._fishing_bobber.animations.push(animationCastBobber);
            self._fishing_bobber.visibility = 0;
            self._cast_animation.addTargetedAnimation(animationCastBobber, self._fishing_bobber);
            //add the bobber to the water
            self._waterMaterial.addToRenderList(self._fishing_bobber);
        });
        BABYLON.SceneLoader.ImportMesh("", "models/", "lure.glb", self._scene, function (newMeshes) {
            newMeshes[0].name = "lure";
            self._fishing_lure = newMeshes[0];
            self._fishing_lure.position = new BABYLON.Vector3(180, 40, -100);
            self._fishing_lure.scaling = new BABYLON.Vector3(.3, .3, .3);
            // define curved path for lure to animate on
            var castCubicBezierVectors = BABYLON.Curve3.CreateCubicBezier(new BABYLON.Vector3(180, 40, -100), new BABYLON.Vector3(60, 50, -25), new BABYLON.Vector3(30, 60, -20), new BABYLON.Vector3(0, -2, 0), 60);
            // draw line for visual reference of the curve
            //var cubicBezierCurve = BABYLON.Mesh.CreateLines("cbezier", castCubicBezierVectors.getPoints(), self._scene);
            //cubicBezierCurve.color = new BABYLON.Color3(1, 0.6, 0);
            // Create the animation and add to the mesh
            var animationCastLure = new BABYLON.Animation("lure-cast", "position", 30, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
            var keys = [];
            var castCurvePoints = castCubicBezierVectors.getPoints();
            for (i = 0; i < castCurvePoints.length; i++) {
                keys.push({
                    frame: i,
                    value: castCurvePoints[i]
                });
            }
            animationCastLure.setKeys(keys);
            self._fishing_lure.animations = [];
            self._fishing_lure.animations.push(animationCastLure);
            self._cast_animation.addTargetedAnimation(animationCastLure, self._fishing_lure);
            //add the bobber to the water
            self._waterMaterial.addToRenderList(self._fishing_lure);
        });
        ////////// RAY CAST TO FIND WATER HEIGHT ////////////
        var i = 0;
        self._scene.registerBeforeRender(function () {
            if (self._scene.getAnimationGroupByName("fishing").isPlaying && self._fishing_bobber.isEnabled()) {
                // @ts-ignore: _LastTime is private error
                var time = _this._waterMaterial._lastTime / 100000;
                var x = self._fishing_bobber.position.x;
                var z = self._fishing_bobber.position.z;
                self._fishing_bobber.position.y = Math.abs((Math.sin(((x / 0.05) + time * _this._waterMaterial.waveSpeed)) * _this._waterMaterial.waveHeight * _this._waterMaterial.windDirection.x * 5.0) + (Math.cos(((z / 0.05) + time * _this._waterMaterial.waveSpeed)) * _this._waterMaterial.waveHeight * _this._waterMaterial.windDirection.y * 5.0));
            }
        });
    };
    Game.prototype.doCast = function () {
        var self = this;
        self._scene.getMeshByName("lure").isVisible = false;
        self._scene.getAnimationGroupByName("idle").reset();
        self._scene.getAnimationGroupByName("idle").stop();
        self._fishing_bobber.position = new BABYLON.Vector3(180, 40, -100);
        document.dispatchEvent(new Event('game:CastStarted'));
        //self._scene.getAnimationGroupByName("cast").normalize(); // don't do this
        self._scene.getAnimationGroupByName("cast").play(false);
    };
    Game.prototype.doReelIn = function () {
        var self = this;
        self._scene.getAnimationGroupByName("fishing").reset();
        self._scene.getAnimationGroupByName("fishing").stop();
        document.dispatchEvent(new Event('game:ReelInStarted'));
        self._scene.getAnimationGroupByName("reel-in").play(true);
        var min = 1;
        var max = 5;
        // make the lure a longer real
        if (self._fishing_lure.isEnabled()) {
            min = 4;
            max = 8;
        }
        var timerLength = Math.floor((Math.random() * (max - min) + min) * 1000);
        setTimeout(function () {
            self._scene.getAnimationGroupByName("reel-in").stop();
        }, timerLength);
    };
    Game.prototype.reset = function () {
        var self = this;
        if (self._fishing_bobber) {
            self._fishing_bobber.position = new BABYLON.Vector3(180, 40, -100);
        }
        // @ts-ignore: _LastTime is private error
        if (self._scene.getAnimationGroupByName("fishing").isPlaying) {
            self._scene.getAnimationGroupByName("fishing").reset();
            self._scene.getAnimationGroupByName("fishing").stop();
        }
        // @ts-ignore: _LastTime is private error
        if (self._scene.getAnimationGroupByName("reel-in").isPlaying) {
            self._scene.getAnimationGroupByName("reel-in").reset();
            self._scene.getAnimationGroupByName("reel-in").stop();
        }
        self._scene.getAnimationGroupByName("idle").play(true);
    };
    Game.prototype.resize = function () {
        var self = this;
        // forces a redraw based on the canvas size, fixes blurry issue since canvas was hidden
        self._engine.resize();
    };
    Game.prototype.setScene = function (value) {
        var self = this;
        switch (value) {
            case "Eagle River Chain of Lakes":
                self._shoreline.material = this._scene.getMaterialByName("shorelineMaterialEagleRiver");
                self._ground.material = this._scene.getMaterialByName("sandMaterial");
                self._fishing_bobber.setEnabled(true);
                self._fishing_lure.setEnabled(false);
                this._waterMaterial.windDirection = new BABYLON.Vector2(1, 1);
                this._waterMaterial.windForce = -2;
                this._waterMaterial.waveHeight = .1;
                this._waterMaterial.waveLength = .1;
                this._waterMaterial.waveSpeed = 50;
                this._waterMaterial.bumpHeight = 0.1;
                break;
            case "Lake Michigan":
                self._shoreline.material = this._scene.getMaterialByName("shorelineMaterialLakeMichigan");
                self._ground.material = this._scene.getMaterialByName("blueMaterial");
                self._fishing_bobber.setEnabled(false);
                self._fishing_lure.setEnabled(true);
                this._waterMaterial.windDirection = new BABYLON.Vector2(-1, -1);
                this._waterMaterial.windForce = -5;
                this._waterMaterial.waveHeight = .5;
                this._waterMaterial.waveLength = .1;
                this._waterMaterial.waveSpeed = 30;
                this._waterMaterial.bumpHeight = 0.1;
                break;
            case "Lake Winnebago":
                self._shoreline.material = this._scene.getMaterialByName("shorelineMaterialLakeWinnebago");
                self._ground.material = this._scene.getMaterialByName("sandMaterial");
                self._fishing_bobber.setEnabled(true);
                self._fishing_lure.setEnabled(false);
                this._waterMaterial.windDirection = new BABYLON.Vector2(-1, -1);
                this._waterMaterial.windForce = -3;
                this._waterMaterial.waveHeight = .5;
                this._waterMaterial.waveLength = .1;
                this._waterMaterial.waveSpeed = 30;
                this._waterMaterial.bumpHeight = 0.1;
                break;
            case "Chippewa Flowage":
                self._shoreline.material = this._scene.getMaterialByName("shorelineMaterialChippewaFlowage");
                self._ground.material = this._scene.getMaterialByName("sandMaterial");
                self._fishing_bobber.setEnabled(true);
                self._fishing_lure.setEnabled(false);
                this._waterMaterial.windDirection = new BABYLON.Vector2(1, 1);
                this._waterMaterial.windForce = -5;
                this._waterMaterial.waveHeight = .2;
                this._waterMaterial.waveLength = .1;
                this._waterMaterial.waveSpeed = 50;
                this._waterMaterial.bumpHeight = 0.1;
                break;
        }
    };
    Game.prototype.doRender = function () {
        var _this = this;
        // Run the render loop.
        this._engine.runRenderLoop(function () {
            _this._scene.render();
        });
        // The canvas/window resize event handler.
        window.addEventListener('resize', function () {
            _this._engine.resize();
        });
    };
    return Game;
}());
window.addEventListener('DOMContentLoaded', function () {
    // Create the game using the 'renderCanvas'.
    // @ts-ignore:
    app.game = new Game('renderCanvas');
    // Create the scene.
    // @ts-ignore:
    app.game.createScene();
    // Start render loop.
    // @ts-ignore:
    app.game.doRender();
});
